import apiClient from "./apiClient";
import datos from "../../src/data/geojson/json/generatedConfig.json"; 

const DEPARTAMENTOS = datos.zonasIndustriales.departamento;
const PROVINCIAS = datos.zonasIndustriales.provincia;
const DISTRITOS = datos.zonasIndustriales.distrito;

 
function getCode(valueOrOption) {
  if (!valueOrOption) return null;
  if (typeof valueOrOption === "string" || typeof valueOrOption === "number") {
    return String(valueOrOption);
  }
  // caso objeto { label, value, ... }
  if (typeof valueOrOption === "object" && valueOrOption.value != null) {
    return String(valueOrOption.value);
  }
  return null;
}

// ===== Helpers locales (JSON) para anidado =====

export function getDepartamentos() {
  return DEPARTAMENTOS;
}

export function getProvinciasPorDepartamento(departamentoSeleccionado) {
  const codDepartamento = getCode(departamentoSeleccionado);
  if (!codDepartamento) return [];
  return PROVINCIAS.filter((prov) =>
    String(prov.value).startsWith(codDepartamento)
  );
}

export function getDistritosPorProvincia(provinciaSeleccionada) {
  const codProvincia = getCode(provinciaSeleccionada);
  if (!codProvincia) return [];
  return DISTRITOS.filter((dist) =>
    String(dist.value).startsWith(codProvincia)
  );
}

// ===== Llamadas al API (si aún las usas) =====

const getUbigeosDepartamento = async (cod = "null") => {
  try {
    const response = await apiClient.post(
      `SigiProdMici/GetParquesIndrustrialesTemps?CodigoIntervencion=${cod}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Error en departamento" };
  }
};

const getUbigeosProvincia = async (cod) => {
  try {
    const response = await apiClient.post(
      `SigiProdMici/GetParquesIndrustrialesTemps?CodigoIntervencion=${cod}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Error en provincias" };
  }
};

const getUbigeosDistrito = async (cod) => {
  try {
    const response = await apiClient.post(
      `SigiProdMici/GetParquesIndrustrialesTemps?CodigoIntervencion=${cod}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Error en distritos" };
  }
};

const getUbigeos = {
  getUbigeosDepartamento,
  getUbigeosProvincia,
  getUbigeosDistrito,
};

export default getUbigeos;
